"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  // All components align to an 8dp square baseline grid for mobile, tablet, and desktop.
  // https://material.io/guidelines/layout/metrics-keylines.html#metrics-keylines-baseline-grids
  unit: 8
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/styles/spacing.js
// module id = 183
// module chunks = 35783957827783 114276838955818 162898551421021